import React, { useContext } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from 'pages/Login'
import SignUpPage from 'pages/SignUp'
import OurProductsPage from 'pages/OurProducts'
import DownloadPage from 'pages/Download'
import ContactUsPage from 'pages/ContactUs'
import PrivacyPolicyPage from 'pages/PrivacyPolicy'
import WarrantyPage from 'pages/Warranty'
import TermsConditionsPage from 'pages/TermsConditions'
import AboutUsPage from 'pages/AboutUs'
import ReturnRefundPolicyPage from 'pages/ReturnRefundPolicy'
import PasswordResetPage from 'pages/PasswordReset'
import NotFoundPage from 'pages/NotFound'
import { AuthContext } from 'contexts/AuthContext'
import ProductDetailPage from 'pages/ProductDetail'
import CabinetPage from 'pages/Cabinets'
import ActivateAccount from 'pages/ActivateAccount'

const PublicRoutes = () => {
  const { isAuthenticated } = useContext(AuthContext)
  return (
    <Routes>
      {isAuthenticated ? (
        <Route path='/login' element={<Navigate to='/my-account' replace />} />
      ) : (
        <Route path='/login' element={<LoginPage />} />
      )}
      <Route path='/signup' element={<SignUpPage />} />
      <Route path='/download' element={<DownloadPage />} />
      <Route path='/our-products' element={<OurProductsPage />} />
      <Route path='/cabinets/:color' element={<CabinetPage />} />
      <Route path='/products/:productId' element={<ProductDetailPage />} />
      <Route path='/contact-us' element={<ContactUsPage />} />
      <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
      <Route
        path='/return-refund-policy'
        element={<ReturnRefundPolicyPage />}
      />
      <Route path='/warranty' element={<WarrantyPage />} />
      <Route path='/terms-conditions' element={<TermsConditionsPage />} />
      <Route path='/about-us' element={<AboutUsPage />} />
      <Route path='/password-reset' element={<PasswordResetPage />} />
      <Route
        path='/activate-account/:accountId'
        element={<ActivateAccount />}
      />
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  )
}

export default PublicRoutes
